import { API_BASE_URL } from "../config";

export type MeResponse = {
  id: number;
  email: string;
  username: string;
  is_staff: boolean;
  is_org_admin: boolean;
  organization: { short_name: string; name: string } | null;
  self_serve_credential_management_enabled?: boolean;
  organization_credential_management_enabled?: boolean;
};

export const fetchMe = async (accessToken: string): Promise<MeResponse> => {
  const res = await fetch(`${API_BASE_URL}/api/v1/me`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch user info.");
  }

  return res.json();
};
